// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.boostads.CustomerAnalyticsUserBoostPreviewWebApiHandler

import { getClient } from '../../client';
import { httpApiRequest } from '@zg-rentals/ts-client-http-client';

import type { CpmBoostAdPreviewsDto } from '../..';

interface GetBoostPreviewForConfirmationParams {
  previewId: string;
}
interface GetV2Params {
  insertionOrderId: string;
  isSingleFamily?: boolean;
}

export const CustomerAnalyticsUserBoostPreviewWebApiHandler_getBoostPreviewForConfirmation_Path =
  '/api/web/v1/users/boostPreview/getBoostPreviewForConfirmation';

/**
 * Generates boost ads preview. The link to the preview page going to be included in a go-live email sent to partners, informing them that their ads have been created and allowing them to verify the ads.
 */
export const CustomerAnalyticsUserBoostPreviewWebApiHandler_getBoostPreviewForConfirmation = (
  getParams: GetBoostPreviewForConfirmationParams,
  client = getClient(),
) => {
  return httpApiRequest<GetBoostPreviewForConfirmationParams, never, CpmBoostAdPreviewsDto>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsUserBoostPreviewWebApiHandler_getBoostPreviewForConfirmation_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};

export const CustomerAnalyticsUserBoostPreviewWebApiHandler_getV2_Path = '/api/web/v1/users/boostPreview/getV2';

/**
 * Get boost ad previews to show in Ad Spend page.
 */
export const CustomerAnalyticsUserBoostPreviewWebApiHandler_getV2 = (getParams: GetV2Params, client = getClient()) => {
  return httpApiRequest<GetV2Params, never, CpmBoostAdPreviewsDto>(
    {
      getParams: getParams,
      endpoint: CustomerAnalyticsUserBoostPreviewWebApiHandler_getV2_Path,
      method: 'GET',
      contextPath: '/customer-analytics',
      unwrapApiLayerResponse: true,
    },
    client,
  );
};
